export const loadReportPages = () => import("./ReportPages");
